import {TheCageSymbol, TheCageSymbolStates} from "./TheCageSymbol";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {gsap} from "gsap";
import {TheCage} from "../TheCage";
import {TheCageSound} from "../sound/TheCageSound";
import {ReelView} from "../../core/reel/simplereel/SimpleReelModel";


export class XBombSymbol extends TheCageSymbol {


    constructor(symbolName:string, initState:TheCageSymbolStates, reelsView: ReelView) {
        super(symbolName, initState, reelsView);


    }


    destroy(options?:{children?:boolean; texture?:boolean; baseTexture?:boolean}) {
        if (this._spine) {
            this._spine.state.setEmptyAnimation(0, 0);
        }
        super.destroy(options);
    }

    public getWinAnimation(state:TheCageSymbolStates):gsap.core.Timeline {
        const highlightSuffix = this.getWinHighlightSuffix(state);
        const tl = gsap.timeline();
        const spine = this.getSymbolSpine(this.symbolName, false);
        if (spine){
            tl.add(()=>{
                this.view.addChild(spine);
                this.setState(TheCageSymbolStates.WIN_LARGE, "none");
            })
            tl.add(() => this.moveToOverlayLayer());
            tl.add(SpineGSAPWrapper.createTimeline(spine, 0, `WinHL_${highlightSuffix}`));
            tl.add(this.getIdleAnimation());
        }
        return tl;
    }

    protected getExplosionAnimation():gsap.core.Timeline {
        const tl = gsap.timeline();
        const spine = this.getSymbolSpine(this.symbolName, false);
        if (spine){
            tl.add(()=>{
                this.view.addChild(spine);
                this.setState(TheCageSymbolStates.EXPLODE, "none");
                spine.autoUpdate = true;
                spine.updateTransform();
            })
            tl.add(() => this.moveToOverlayLayer());
            tl.add(SpineGSAPWrapper.createTimeline(spine, 0, 'explode'));
            tl.add(()=>{TheCage.soundPlayer.stopSound(TheCageSound.X_BOMB_EXPLODE_FUSE_LOOP)}, "<0.6");
        }
        return tl;
    }

    protected getLandingAnimation(state:TheCageSymbolStates):gsap.core.Timeline {
        const tl = gsap.timeline();
        const spine = this.getSymbolSpine(this.symbolName, false);
        tl.add(() => this.moveToOverlayLayer());
        if (spine){
            tl.add(()=>{
                this.view.addChild(spine);
                this.setState(TheCageSymbolStates.LANDING, "none");
                spine.autoUpdate = true;
                spine.updateTransform();
            })
            tl.add(SpineGSAPWrapper.createTimeline(spine, 0, `landing`));
            tl.add(this.getIdleAnimation());
        }

        return tl;
    }

    public instantIdleAnimation() {
        const spine = this.getSymbolSpine(this.symbolName, false);
        this.moveToWinLayer();
        if (spine) {
            this.view.addChild(spine);
            this.setState(TheCageSymbolStates.NORMAL, "none");
            spine.autoUpdate = true;
            spine.updateTransform();
            spine.state.setAnimation(0, "idle", true);
        }
    }

    public getIdleAnimation() {
        const tl = gsap.timeline();
        const spine = this.getSymbolSpine(this.symbolName, false);
        tl.add(() => this.moveToWinLayer());
        if (spine){
            tl.add(()=>{
                this.view.addChild(spine);
                this.setState(TheCageSymbolStates.NORMAL, "none");
            })
            tl.add(() => {spine.state.setAnimation(0, "idle", true)});
        }

        return tl;
    }

    public getWildMining() {
        const tl = gsap.timeline();
        const spine = this.getSymbolSpine(this.symbolName, false);
        tl.add(() => this.moveToWinLayer());
        if (spine){
            tl.add(()=>{
                this.view.addChild(spine);
                this.setState(TheCageSymbolStates.NORMAL, "none");
                spine.autoUpdate = true;
                spine.updateTransform();
            })
            tl.add(SpineGSAPWrapper.createTimeline(spine, 0, "wildMining"));
            tl.add(this.getIdleAnimation());
        }

        return tl;
    }
}